import {
    ICurrencyServiceMock
} from './index'

export const mockCurrencyService = (): ICurrencyServiceMock => ({
    getAll: jest.fn(),
    getPrice: jest.fn()
})
